(function () {
  function initCollectionNavigation(container) {
    if (!container || container.dataset.collectionNavigationInitialized) {
      return;
    }

    container.dataset.collectionNavigationInitialized = 'true';

    const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';

    const links = container.querySelectorAll(
      '.collection-navigation__link'
    );

    links.forEach(function (link) {
      const rawHref = link.getAttribute('href');

      // Skip placeholder / empty links entirely
      if (!rawHref || rawHref === '#' || rawHref.trim() === '') {
        return;
      }

      const linkUrl = new URL(link.href, window.location.origin);

      // Skip links that are just a hash on the current page
      if (linkUrl.pathname === window.location.pathname && rawHref.startsWith('#')) {
        return;
      }

      const linkPath = linkUrl.pathname.replace(/\/+$/, '') || '/';

      if (linkPath === currentPath) {
        link.classList.add('is-active');
        link.setAttribute('aria-current', 'page');

        let item = link.closest('.collection-navigation__item');

        while (item) {
          item.classList.add('is-open');

          const toggle = item.querySelector(
            ':scope > .collection-navigation__row .collection-navigation__toggle'
          );

          if (toggle) {
            toggle.setAttribute('aria-expanded', 'true');
          }

          item = item.parentElement?.closest(
            '.collection-navigation__item'
          );
        }
      }
    });

    container.addEventListener('click', function (event) {
      const toggle = event.target.closest(
        '.collection-navigation__toggle'
      );

      if (!toggle) return;

      event.preventDefault();

      const item = toggle.closest(
        '.collection-navigation__item'
      );

      if (!item) return;

      const isOpen = item.classList.toggle('is-open');

      toggle.setAttribute(
        'aria-expanded',
        isOpen ? 'true' : 'false'
      );
    });
  }

  function initAllCollectionNavigations() {
    document
      .querySelectorAll('.collection-navigation')
      .forEach(initCollectionNavigation);
  }

  document.addEventListener(
    'DOMContentLoaded',
    initAllCollectionNavigations
  );

  document.addEventListener(
    'shopify:section:load',
    initAllCollectionNavigations
  );
})();